"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertArgument = exports.noop = exports.fetchSuccess = exports.FetchError = void 0;
const assert_1 = require("assert");
const util = require("util");
class FetchError extends Error {
    constructor(message, code, data) {
        super(message);
        this.message = message;
        this.code = code;
    }
}
exports.FetchError = FetchError;
function fetchSuccess(result) {
    if (result.code === 200) {
        return Promise.resolve(result.data);
    }
    return Promise.reject(new FetchError(result.message, result.code, result.data));
}
exports.fetchSuccess = fetchSuccess;
function noop(...args) {
    // console.log(JSON.stringify(args))
}
exports.noop = noop;
function assertArgument(options, key) {
    assert_1.strict.ok(!util.isNullOrUndefined(options[key]), `arguments error, unexpect ${key}: ${options[key]}`);
}
exports.assertArgument = assertArgument;
//# sourceMappingURL=utils.js.map